import { render, staticRenderFns } from "./worldMapData.vue?vue&type=template&id=372ac756&scoped=true"
import script from "./worldMapData.vue?vue&type=script&lang=js"
export * from "./worldMapData.vue?vue&type=script&lang=js"
import style0 from "./worldMapData.vue?vue&type=style&index=0&id=372ac756&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372ac756",
  null
  
)

export default component.exports